import { ipsos, supuesto } from ".";

// Lámina 56 (alcohólicas, base 400/275) y lámina 58 (no alcohólicas, base 400).
const P_CONSUME_ALC = "¿Consume bebidas alcohólicas?";
const P_TIPO_ALC = "¿Qué tipo de bebida alcohólica es su preferida?";
const P_MARCA_ALC = "¿Tiene alguna marca preferida?";
const P_TIPOS_NO_ALC = "¿Qué bebidas no alcohólicas consume usted?";
const P_LIGHT_ZERO = "¿Consume usted bebidas Light o Zero?";

export const IPSOS_ALCOHOLICAS = {
  consume: ipsos(0.689, { lamina: 56, pregunta: P_CONSUME_ALC, base: 400 }),
  noConsume: ipsos(0.311, { lamina: 56, pregunta: P_CONSUME_ALC, base: 400 }),
  tipoPreferido: {
    Cerveza: ipsos(0.474, { lamina: 56, pregunta: P_TIPO_ALC, base: 275 }),
    Pisco: ipsos(0.163, { lamina: 56, pregunta: P_TIPO_ALC, base: 275 }),
    Gin: ipsos(0.099, { lamina: 56, pregunta: P_TIPO_ALC, base: 275 }),
    Whisky: ipsos(0.053, { lamina: 56, pregunta: P_TIPO_ALC, base: 275 }),
    Ron: ipsos(0.021, { lamina: 56, pregunta: P_TIPO_ALC, base: 275 }),
    Otros: ipsos(0.184, {
      lamina: 56,
      pregunta: P_TIPO_ALC,
      base: 275,
      nota: "no incluye 'Licores' (0,6%), omitido en el código actual",
    }),
  },
  // 11 marcas más mencionadas (base 275), excluye "No Recuerda La Marca"/"No Tiene Marca Preferida"
  marcas: {
    "Alto del Carmen": ipsos(0.129, { lamina: 56, pregunta: P_MARCA_ALC, base: 275 }),
    "Cervezas artesanales": ipsos(0.116, { lamina: 56, pregunta: P_MARCA_ALC, base: 275 }),
    Corona: ipsos(0.106, { lamina: 56, pregunta: P_MARCA_ALC, base: 275 }),
    "Johnnie Walker": ipsos(0.077, { lamina: 56, pregunta: P_MARCA_ALC, base: 275 }),
    "Stella Artois": ipsos(0.056, { lamina: 56, pregunta: P_MARCA_ALC, base: 275 }),
    Austral: ipsos(0.049, { lamina: 56, pregunta: P_MARCA_ALC, base: 275 }),
    Chocalan: ipsos(0.045, { lamina: 56, pregunta: P_MARCA_ALC, base: 275 }),
    Branca: ipsos(0.041, { lamina: 56, pregunta: P_MARCA_ALC, base: 275 }),
    "Jack Daniels": ipsos(0.039, { lamina: 56, pregunta: P_MARCA_ALC, base: 275 }),
    Kunsman: ipsos(0.037, { lamina: 56, pregunta: P_MARCA_ALC, base: 275 }),
    Pilsen: ipsos(0.034, { lamina: 56, pregunta: P_MARCA_ALC, base: 275 }),
  },
};

export const IPSOS_NO_ALCOHOLICAS = {
  // Multirespuesta — % que consume cada tipo (base 400)
  tipos: {
    Aguas: ipsos(0.717, { lamina: 58, pregunta: P_TIPOS_NO_ALC, base: 400, nota: "multirespuesta" }),
    "Bebidas / Gaseosas": ipsos(0.631, { lamina: 58, pregunta: P_TIPOS_NO_ALC, base: 400, nota: "multirespuesta" }),
    "Jugos naturales": ipsos(0.307, { lamina: 58, pregunta: P_TIPOS_NO_ALC, base: 400, nota: "multirespuesta" }),
    "Aguas saborizadas": ipsos(0.215, { lamina: 58, pregunta: P_TIPOS_NO_ALC, base: 400, nota: "multirespuesta" }),
    "Jugos de frutas": ipsos(0.199, { lamina: 58, pregunta: P_TIPOS_NO_ALC, base: 400, nota: "multirespuesta" }),
    Isotónicas: ipsos(0.148, { lamina: 58, pregunta: P_TIPOS_NO_ALC, base: 400, nota: "multirespuesta" }),
    Energizantes: ipsos(0.146, { lamina: 58, pregunta: P_TIPOS_NO_ALC, base: 400, nota: "multirespuesta" }),
  },
  consumeLightZero: ipsos(0.71, { lamina: 58, pregunta: P_LIGHT_ZERO, base: 400 }),
  noConsumeLightZero: ipsos(0.29, { lamina: 58, pregunta: P_LIGHT_ZERO, base: 400 }),
};

// Supuestos comerciales — opciones del simulador y referencias de mercado estimado
export const TICKETS_ALCOHOLICAS = [
  supuesto(8000, { nota: "ticket promedio alcohólicas" }),
  supuesto(15000, { nota: "ticket promedio alcohólicas" }),
  supuesto(25000, { nota: "ticket promedio alcohólicas" }),
  supuesto(40000, { nota: "ticket promedio alcohólicas" }),
];
export const FRECUENCIA_MENSUAL = [
  supuesto(2, { nota: "ocasiones de consumo por mes" }),
  supuesto(4, { nota: "ocasiones de consumo por mes" }),
  supuesto(6, { nota: "ocasiones de consumo por mes" }),
  supuesto(8, { nota: "ocasiones de consumo por mes" }),
];
export const TICKETS_NO_ALCOHOLICAS = [
  supuesto(500, { nota: "ticket promedio no alcohólicas" }),
  supuesto(1000, { nota: "ticket promedio no alcohólicas" }),
  supuesto(2000, { nota: "ticket promedio no alcohólicas" }),
  supuesto(3500, { nota: "ticket promedio no alcohólicas" }),
];
export const FRECUENCIA_SEMANAL = [
  supuesto(1, { nota: "compras por semana" }),
  supuesto(2, { nota: "compras por semana" }),
  supuesto(3, { nota: "compras por semana" }),
  supuesto(5, { nota: "compras por semana" }),
  supuesto(7, { nota: "compras por semana" }),
];
export const ESCENARIOS_CAPTACION = [
  supuesto(2, { nota: "escenario de captación de mercado" }),
  supuesto(4, { nota: "escenario de captación de mercado" }),
  supuesto(6, { nota: "escenario de captación de mercado" }),
  supuesto(8, { nota: "escenario de captación de mercado" }),
  supuesto(10, { nota: "escenario de captación de mercado" }),
];

// Referencias fijas para el mercado estimado (medianas de los selects de arriba)
export const TICKET_REF_ALC = supuesto(15000, { nota: "referencia de mercado mensual estimado" });
export const FREC_REF_ALC = supuesto(4, { nota: "referencia de mercado mensual estimado" });
export const TICKET_REF_NO_ALC = supuesto(1000, { nota: "referencia de mercado semanal estimado" });
export const FREC_REF_NO_ALC = supuesto(3, { nota: "referencia de mercado semanal estimado" });
export const SEMANAS_MES = supuesto(4, { nota: "semanas por mes" });
